const style = () => ({});
export default style;
